import { appendErrors, useForm } from "react-hook-form";
import { useState, useEffect } from "react";

import {
  pvt_details_of_shareholder,
  pvt_lmt_registration,
  private_shareholder,
} from "./PrivateCompanyRegistrationArr";
import Images from "../../../../media/images";
import axios from "axios";
import BackButton from "../../../../components/common/backbutton/BackButton";
import api from "../../../../api/api";
import { toast, ToastContainer } from "react-toastify";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../components/common/forms/FormPayment";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";

const PrivateCompanyRegistration = () => {
  const { register, handleSubmit, unregister } = useForm();

  const [tableRow, setTableRow] = useState(1);
  const [addIcon, setAddIcon] = useState(true);
  // for share holders
  const [shareHolders, setShareHolders] = useState([
    {
      name: "",
      address: "",
      share_amount: "",
      citizenship: "",
      witness_name: "",
      witness_address: "",
      witness_citizenship: "",
    },
  ]);

  const [paymentRangeList, setPaymentList] = useState([]);
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);

  const [uploadProof, setUploadProof] = useState("");
  const [amount, setAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  // for filtering by company_type and show in Modal
  useEffect(() => {
    api
      .get(
        "/services/company/registration/service-charges/?company_type=private"
      )
      .then((response) => {
        setPaymentList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // For amount calculation
  useEffect(() => {
    console.log("amount", amount);
    if (amount > 0) {
      let arr = paymentRangeList.filter((item) => {
        return (
          amount >= parseInt(item.range_start) &&
          amount <= parseInt(item.range_end)
        );
      });
      console.log(arr);

      arr.length > 0 && setTotalAmount(arr[0]?.amount);
    } else {
      setTotalAmount(0);
    }
  }, [amount, paymentRangeList]);

  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);

  const handleClick = (data) => {
    console.log("upload");
    // data['company_type'] = "private"
    data.company_type = "private";
    data.share_holders = shareHolders;

    // if no documents then pass empty array
    data.documents = [];

    //getting token from localstorage
    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        // console.log(response.data);
        // toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: 2500,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        console.log(error);
        toast.error("Data Registration Failed.");
      });
  };

  // table add and remove

  return (
    <>
      <div>
        <div className="">
          <form className="px-10 lg:!px-14">
            <h1 className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
              {/* {slug.split("-")[0]} */}
              Pvt.Ltd. Company Registration Form
            </h1>

            <div className="mt-3">
              {(user?.user_type === "ST" || user?.user_type === "AD") && (
                <AdminSearchCustomer setUserId={setUserId} />
              )}
            </div>

            {/* company name details */}
            <div className="mt-5">
              <p className="text-primary-blue font-Calistoga text-lg underline">
                1. Company Name Details
              </p>
              {/* table form */}
              <div className="flex lex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                    <div className="overflow-x-auto">
                      <table className="border  border-3">
                        <thead>
                          <tr>
                            <td className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                              S. N.
                            </td>
                            <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                              Company Name 1
                            </td>
                            <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                              Company Name 2
                            </td>
                            <td className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                              Company Name 3
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-primary-blue border">
                            <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                              English मा
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 w-full py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                          </tr>
                          <tr className="border-primary-blue border">
                            <td className="text-primary-red font-Laila border-primary-blue border-r px-10 text-center font-semibold">
                              नेपालीमा मा
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                            <td className="p-0">
                              <input
                                type="text"
                                name=""
                                className="border-primary-blue text-primary-blue m-0 w-full py-3 px-3 outline-none"
                                id=""
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-primary-blue mt-3 text-base font-Laila font-medium leading-10 md:!text-lg">
                तपाईले दर्ता गर्न चाहनुभएको प्रस्तावित Company को नाम नेपाली र
                अंग्रेजी दुबै भाषामा प्रस्ट बुझिनेगरी माथिको फर्ममा उल्लेख
                गर्नुहोस् । एउटा कम्पनीको बढिमा ३ वटा सम्म नाम रिजर्भको लागि पेश
                गर्न सकिनेछ ।
              </p>
            </div>
            {/* others details */}
            <div className="mt-5">
              <p className="text-primary-blue font-Calistoga text-lg underline">
                2. Others Details
              </p>
              <div className="mt-5 flex  items-center flex-col md:flex-row gap-5">
                <div className="border-primary-blue md:w-[60rem] border relative  font-bold">
                  <div className="md:absolute hidden md:block border-1 font-Laila border text-primary-blue bottom-0  border-primary-blue right-0  w-[28%] z-40 bg-red-200 ">
                    शेयर सदस्य तथा पुँजी आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                    <span className="text-red-600">रु.{totalAmount}।–</span>{" "}
                    मात्र
                  </div>
                  <div>
                    {pvt_lmt_registration.map((item, i) => {
                      const { name, validation, ip1, type } = item;
                      // console.log(item);
                      return (
                        <div
                          key={i}
                          className="border-primary-blue flex flex-col border md:flex-row"
                        >
                          <p className="text-primary-red font-Laila px-5 py-2 sm:!w-[300px]">
                            {ip1}
                          </p>

                          {item.ip1 === " कम्पनीको प्रकार" ? (
                            <>
                              <div className="border-primary-blue flex w-full items-center gap-5  py-2 pl-2 md:border-l md:!py-0">
                                <div
                                  onClick={() => setAddIcon(true)}
                                  className="border-primary-blue font-Laila bg-primary-red flex items-center justify-center gap-1 rounded-full  p-1 text-white"
                                >
                                  <label htmlFor="ekal">एकल</label>
                                  <input
                                    type="radio"
                                    id="ekal"
                                    value="ekal"
                                    {...register("business_type", {
                                      required: false,
                                    })}
                                  />
                                </div>

                                <div
                                  onClick={() => setAddIcon(false)}
                                  className="border-primary-blue bg-primary-red rounded-full p-1 text-white"
                                >
                                  <label htmlFor="bahul">बहुल</label>
                                  <input
                                    type="radio"
                                    id="bahul"
                                    {...register("business_type", {
                                      required: false,
                                    })}
                                    value="bahul"
                                  />
                                </div>
                              </div>
                            </>
                          ) : (
                            <input
                              type={type}
                              {...register(name, {
                                onChange: (e) => {
                                  e.target.name === "total_capital" &&
                                    setAmount(e.target.value);
                                },
                              })}
                              className="border-primary-blue w-full  py-2 pl-3 outline-none md:border-l"
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="">
                  <div className="border-primary-red text-primary-blue font-Laila w-fit rounded-full border-2 p-2 text-xl">
                    Pvt. Ltd. Company दर्ता शुल्क सम्बन्धि पूर्ण जानकारी लिनको
                    लागि यहाँ गर्नुहोस <span
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalEdit"
                      className="text-primary-red cursor-pointer"
                    >
                      Click
                    </span>
                    <PrivateCompanyModal paymentRangeList={paymentRangeList} />
                  </div>

                  {/* const state  = [{name:, address:}, {name: , address}] */}

                  {/* <img
                onClick={() => {
                  setTableRow(tableRow + 1)
                  // setShareHolders([{name:'', address: ''}])
                  setShareHolders(shareHolders => [...shareHolders, { name: "", address: "", share_amount: "", citizenship: "", witness_name: "", witness_address: "", witness_citizenship: "" }])


                  console.log(shareHolders)

                }

                }
                src={Images.row_add}
                className="h-10 w-10 cursor-pointer"
                alt=""
                srcSet=""
              /> */}
                </div>
              </div>
            </div>
            {/* pricing details */}

            {/* share holder details */}
            <div className="mt-5">
              <div className="flex flex-wrap justify-between">
                <p className="text-primary-red font-Calistoga text-lg underline">
                  3. Details of Share Holders
                  <span className="text-primary-blue font-Calistoga underline">
                    (शेयर सदस्य तथा साँक्षीहरुको विवरण) (प्रा.लि. कम्पनीमा बढिमा
                    १०१ जना सम्म सदस्य रहन सकिन्छ ।)
                  </span>
                </p>

                {/* const state  = [{name:, address:}, {name: , address}] */}
                {addIcon === false && (
                  <img
                    onClick={() => {
                      setTableRow(tableRow + 1);
                      // setShareHolders([{name:'', address: ''}])
                      setShareHolders((shareHolders) => [
                        ...shareHolders,
                        {
                          name: "",
                          address: "",
                          share_amount: "",
                          citizenship: "",
                          witness_name: "",
                          witness_address: "",
                          witness_citizenship: "",
                        },
                      ]);

                      console.log(shareHolders);
                    }}
                    src={Images.row_add}
                    className="h-10 w-10 cursor-pointer"
                    alt=""
                    srcset=""
                  />
                )}
              </div>
              <div className="flex justify-end"></div>
              {/* share holder details form */}
              <div className="flex flex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full sm:px-6 lg:px-8">
                    <DetailsOfShareHolders
                      DetailShareholder={pvt_details_of_shareholder}
                      needed_share={private_shareholder}
                      setShareHolders={setShareHolders}
                      shareHolders={shareHolders}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* company objective */}
            <div className="mt-5">
              <p className="text-primary-blue font-Calistoga text-lg underline">
                4. Main Objectives
                <span className="text-primary-blue font-Laila underline">
                  (कम्पनीले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
                </span>
              </p>
              <MainObjectives register={register} />
            </div>
            {/* branch */}
            <div className="mt-5">
              <p className="text-primary-blue font-Calistoga text-lg underline">
                5. Working Branch
                <span className="text-primary-blue font-Laila underline">
                  (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो
                  कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
                </span>
              </p>
              {/* radio buttons */}

              {/* <FormBranch/> */}
              <FormBranch register={register} />
            </div>
            {/* sumbit modal */}
            <FormButtom />
            <FormPayment
              handleSubmit={handleSubmit}
              handleClick={handleClick}
              setUploadProof={setUploadProof}
              totalAmount={totalAmount}
              dueAmount={dueAmount}
              setPaidAmount={setPaidAmount}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default PrivateCompanyRegistration;
